module.exports = ".exceed_warning{\n    color: #FC0404;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/education-form/edu-detail/education/education.component.css
// module id = ./src/app/main/content/education-form/edu-detail/education/education.component.css
// module chunks = main